export default "__VITE_ASSET__CEqZgpwL__"